export const priceToCents = (price: string) => parseInt((parseFloat(price) * 100).toFixed(2));

export const centsToPrice = (price?: number | string) => {
    const formattedPrice = Number(price);

    if (formattedPrice && !Number.isNaN(formattedPrice)) {
        return (formattedPrice / 100).toFixed(2);
    }

    return "0";
};


export const centsToPriceFourDecimals = (price?: number | string) => {
    const formattedPrice = Number(price);

    if (formattedPrice && !Number.isNaN(formattedPrice)) {
        return (formattedPrice / 10000).toFixed(4);
    }

    return "0";
};